// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__31f27","calendarButtons":"ClockData_calendarButtons__3yP9Q"};